module.exports = __webpack_public_path__ + "static/media/dental_placeholder.9fb2654f.png";